/**
 * 排出事業者 取扱品目
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/emissions`

const emission_item = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     *
     * @param commit
     * @param emission_id
     * @return {Promise<unknown>}
     */
    show ({ commit }, { emission_id, page }) {
      const api_path = `${API_PATH}/${emission_id}/items`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: {page: page } }).then(data => {
          resolve(data.content)
        })
      })
    },
    edit ({ commit }, { emission_id }) {
      const api_path = `${API_PATH}/${emission_id}/items/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ emission_id, params }) {
      const api_path = `${API_PATH}/${emission_id}/items`
      return new Promise( ( resolve ) => {
        Vue.$http.patch(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { emission_id, id }) {
      const api_path = `${API_PATH}/${emission_id}/items/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default emission_item

